import { RefObject, useCallback } from 'react';
import { usePagination } from 'react-instantsearch';
import styled, { css } from 'styled-components';

import PaginationAtom from '@sorare/core/src/atoms/navigation/Pagination';

interface Props {
  rootRef: RefObject<HTMLDivElement>;
  visible: boolean;
}

const Wrapper = styled.div<{ $visible: boolean }>`
  /* give some space so that the mobile filters don't overlap as well as making the desktop usage easier */
  padding: var(--quadruple-unit) 0;
  ${({ $visible }) =>
    !$visible
      ? css`
          display: none;
        `
      : ''}
`;

export const Pagination = ({ rootRef, visible }: Props) => {
  const { currentRefinement, nbPages, refine } = usePagination();

  const goToPage = useCallback(
    (page: number) => {
      if (rootRef.current) {
        // We should use EnsureTopVisibleOnMount to handle this
        // but Algolia components do not handle navigation through
        // React router so we can not detected pagination change
        // on router level
        window.scrollTo({
          top: rootRef.current.offsetTop - 100,
          behavior: 'auto',
        });
      }
      refine(page);
    },
    [refine, rootRef]
  );

  return (
    <Wrapper $visible={visible && nbPages > 1}>
      <PaginationAtom
        currentPage={currentRefinement}
        pages={nbPages}
        onSelect={goToPage}
      />
    </Wrapper>
  );
};

export default Pagination;
